module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-row",
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    ref: "header"
  }, [_c('el-row', {
    staticClass: "dark"
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "0 5px"
    },
    attrs: {
      "mode": "horizontal",
      "id": "day-info"
    }
  }, [_c('li', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.datenow)
    }
  })]), _vm._v(" "), (_vm.temp) ? _c('li', [_c('i', {
    staticClass: "fa fa-sun-o"
  }), _vm._v(" " + _vm._s(_vm.temp) + " " + _vm._s(_vm.$t('C')))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "15px 0"
    },
    attrs: {
      "span": 4,
      "align": "center"
    }
  }, [(_vm.$route.name != 'Login' && _vm.$route.name != 'ResetPassword') ? _c('span', {
    staticClass: "navbar-brand"
  }, [_vm._v(_vm._s(_vm.school_name))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.$route.name != 'Login' && _vm.$route.name != 'ResetPassword') ? _c('ul', {
    staticClass: "badges"
  }, [(_vm.hide_sidebar) ? _c('li', {
    staticClass: "badge_icon",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_messages()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('message')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x"
  })])], 1), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_incidents()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('incident')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-2x"
  })])], 1), _vm._v(" "), (_vm.wiot_box == 1) ? _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_violations()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('violation')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer fa-2x"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_trips()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('trip')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bus fa-2x"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allowed_add.length != 0) ? _c('li', {
    staticClass: "entry"
  }, [(_vm.hide_sidebar) ? _c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  " + _vm._s(_vm.$t('ADD')) + "\n       ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.allowed_add), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "divided": item.divide,
        "command": item.command
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "profile"
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.profile_photo, 'user'),
      "alt": _vm.full_name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "profile-name"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  }), _vm._v(" " + _vm._s(_vm.full_name) + " ")])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.hide_sidebar) ? _c('el-dropdown-item', {
    attrs: {
      "command": "profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('MYPROFILE')))]) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save', 'school/configuration') && _vm.hide_sidebar) ? _c('el-dropdown-item', {
    attrs: {
      "command": "school"
    }
  }, [_vm._v(_vm._s(_vm.$t('SCHOOLSETTINGS')))]) : _vm._e(), _vm._v(" "), (_vm.hide_sidebar) ? _c('el-dropdown-item', {
    attrs: {
      "disabled": "",
      "divided": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('LANGUAGES')))]) : _vm._e(), _vm._v(" "), (_vm.lang != 'en') ? _c('el-dropdown-item', {
    attrs: {
      "command": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t('ENGLISH')))]) : _vm._e(), _vm._v(" "), (_vm.lang != 'ar') ? _c('el-dropdown-item', {
    attrs: {
      "command": "ar"
    }
  }, [_vm._v(_vm._s(_vm.$t('ARABIC')))]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": "",
      "command": "logout"
    }
  }, [_vm._v(_vm._s(_vm.$t('LOGOUT')))])], 1)], 1)], 1)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide_sidebar),
      expression: "hide_sidebar"
    }],
    staticClass: "menu",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    ref: "logo",
    attrs: {
      "id": "logo"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('./assets/img/logo.png')
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('WIOT')) + " ")])])], 1), _vm._v(" "), (_vm.hide_sidebar) ? _c('el-scrollbar', {
    ref: "menuScroll",
    staticClass: "my-scrollbar",
    attrs: {
      "viewStyle": {
        height: _vm.sideBarHeight + 'px'
      }
    }
  }, [_c('div', [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "unique-opened": true,
      "router": true
    },
    on: {
      "open": _vm.openMenu
    }
  }, _vm._l((_vm.navigations), function(navigation, key) {
    return _c('div', {
      key: key
    }, [(navigation.menu.length != 0) ? _c('el-submenu', {
      class: [_vm.activeIndex == key && navigation.target != null ? 'activated is-opened' : (navigation.target != null ? 'hide-arrow' : '')],
      attrs: {
        "index": key.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navigation.icon
    }), _vm._v(" " + _vm._s(navigation.name))]), _vm._v(" "), _vm._l((navigation.menu), function(menu, _key) {
      return _c('el-menu-item', {
        key: _key,
        class: [_vm.subMenuActive == key + '' + _key ? 'sub-active' : ''],
        attrs: {
          "index": menu.target
        },
        on: {
          "click": function($event) {
            _vm.subMenuActive = key + '' + _key
          }
        }
      }, [_vm._v(_vm._s(menu.name))])
    })], 2) : _c('el-menu-item', {
      class: [_vm.subMenuActive == key ? 'sub-active' : ''],
      attrs: {
        "index": navigation.target
      },
      on: {
        "click": function($event) {
          _vm.subMenuActive = key.toString()
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navigation.icon
    }), _vm._v(" " + _vm._s(navigation.name))])], 2)], 1)
  }))], 1)]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.hide_sidebar) ? 21 : 24,
      "offset": (_vm.hide_sidebar) ? 3 : 0
    }
  }, [_c('router-view', {
    staticClass: "content"
  })], 1)], 1), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "incident": _vm.incident,
      "visible": _vm.incidentBox
    },
    on: {
      "update:visible": function($event) {
        _vm.incidentBox = $event
      }
    }
  }), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "search": true,
      "visible": _vm.absenceBox,
      "server-check": true
    },
    on: {
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-auth-dialog', {
    attrs: {
      "sessionExpiration": _vm.session_expiration,
      "visible": _vm.sessionDialog,
      "itSelf": true,
      "timer": _vm.timer
    },
    on: {
      "authBack": _vm.sessionExtended,
      "update:visible": function($event) {
        _vm.sessionDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a97100fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 622
// module chunks = 1